import {Component, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-rc-radio',
    template: `<ng-template #signleRadioContent>
  <ng-content></ng-content>
</ng-template>`,
    styles: [``]
})
export class RcRadioComponent {
    @ViewChild('signleRadioContent', {read: TemplateRef}) signleRadioContent;

}